import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";

import { get, keyBy, mapValues } from "lodash";

import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  root: {
    fontSize: "12px",
    color: theme.palette.questionnaire.textPrimary,
    position: "absolute",
    bottom: "5px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "100%"
  },
  link: {
    cursor: "pointer",
    textDecoration: "none",
    color: theme.palette.questionnaire.textPrimary,
    marginLeft: 4
  }
});

const Copyright = ({ classes, environment, name }) => {
  return (
    <Typography
      className={cn(classes.root)}
      align="center"
    >
      <b>SlashData © Copyright {new Date().getFullYear()}</b> | All rights reserved |
      <a
        href={I18n.t("privacy-policy-url", environment)}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.link}
      >
        Privacy Policy |
      </a>
      <a
        href="/cookie-policy"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.link}
      >
        Cookie Policy
      </a>
    </Typography>
  );
};

Copyright.propTypes = {
  classes: PropTypes.shape().isRequired
};

// Create data context by using the defined environment variables in the survey
const createContext = (environment) => {
  return mapValues(keyBy(environment, 'name'), 'value');
};

const mapStateToProps = state => ({
  environment: createContext(get(state, ["survey", "environment"], [])),
  name: get(state, ["survey", "name"])
});

export default connect(mapStateToProps)(withStyles(styles)(Copyright));
